import type { TwiageCase } from "@/App/types/twiageTypes";
import { CasesQuickFilter } from "@/Pages/Cases/CasesQuickFilter";
import type { Filter } from "@/Pages/Cases/filtering/filters/CaseFilter";
import { filterCase } from "@/Pages/Cases/store/filterCases";
import { ComplaintPriority } from "@/App/types/ComplaintPriority";

export const complaintToQuickFilterMap: Map<ComplaintPriority, CasesQuickFilter> = new Map([
  [ComplaintPriority.Critical, CasesQuickFilter.Critical],
  [ComplaintPriority.Urgent, CasesQuickFilter.Urgent],
  [ComplaintPriority.Routine, CasesQuickFilter.Routine],
  [ComplaintPriority.Unknown, CasesQuickFilter.Unknown],
]);

export const isCaseMatchingMainFilters = (twiageCase: TwiageCase, mainFilters: Filter[]): boolean => {
  return filterCase({ twiageCase, filters: mainFilters });
};
